import { t } from 'i18next';
import * as Yup from 'yup';

export const addSuggestion = Yup.object({
  roles: Yup.mixed().required(t('required-field')),
});

